/** Shared layout + form styles for Paramètres pages. */
export const SETTINGS_PANEL_BODY = 'px-5 py-6 sm:px-8 sm:py-8 lg:px-10 lg:py-10';

export const SETTINGS_FORM_GRID =
  'grid grid-cols-1 gap-x-8 gap-y-6 lg:grid-cols-2';

export const SETTINGS_FIELD = 'space-y-2';

export const SETTINGS_LABEL =
  'flex items-center gap-2 text-sm font-medium text-slate-700 dark:text-slate-300';

export const SETTINGS_INPUT =
  'w-full rounded-xl border border-slate-200 bg-white px-4 py-3 text-sm text-slate-900 shadow-sm placeholder:text-slate-400 focus:border-forma-500 focus:outline-none focus:ring-2 focus:ring-forma-500/20 dark:border-slate-600 dark:bg-slate-800/80 dark:text-slate-50 dark:placeholder:text-slate-500';

export const SETTINGS_SELECT = SETTINGS_INPUT;

export const SETTINGS_SECTION =
  'rounded-2xl border border-slate-200 bg-slate-50/80 p-6 dark:border-slate-700 dark:bg-slate-800/40';

export const SETTINGS_SECTION_TITLE =
  'mb-5 flex items-center gap-2 text-base font-semibold text-slate-900 dark:text-slate-50';

export const SETTINGS_PAGE_STACK = 'space-y-8';

export const SETTINGS_HEADER =
  'border-b border-slate-200 pb-6 dark:border-slate-700';

export const SETTINGS_HEADER_TITLE =
  'text-xl font-semibold tracking-tight text-slate-900 dark:text-slate-50';

export const SETTINGS_HEADER_DESC =
  'mt-1 text-sm text-slate-600 dark:text-slate-400';
